import { createBrowserVoiceLifetime } from './lifetime.js';
import { IndexedDbVoiceStorage } from './storage.js';

/** Current password/calendar app and future social composition share device-local voice privacy. */
export async function purgeDeviceVoiceRecordings() {
  const lifetime = createBrowserVoiceLifetime(); lifetime?.publish({ type: 'purged' }); lifetime?.dispose();
  if (typeof indexedDB !== 'undefined') {
    const storage = new IndexedDbVoiceStorage(indexedDB);
    try { await storage.purge(); } finally { storage.close(); }
  }
}
